export default () => {
	return document.documentElement.clientWidth;
};
